import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-full-calendar-pro',
	templateUrl:'./FullCalendarProPluginCompPage.html',
	styles: [],
	styleUrls:['./FullCalendarProPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FullCalendarProPluginCompPage
{
	mdContent_973 = `\`\`\`java
import com.jwebmp.plugins.fullcalendarpro.FullCalendarPro;
\`\`\``;
	mdContent_974 = `\`\`\`java
FullCalendarPro(String id)
\`\`\``;
	mdContent_975 = `\`\`\`java
public class RoomCalendar extends FullCalendarPro<RoomCalendar> {
    public RoomCalendar() {
        super("room-cal");
        getOptions()
            .setInitialView("resourceTimelineDay")
            .setSchedulerLicenseKey("your-key")
            .setResourceAreaHeaderContent("Rooms")
            .setResourceAreaWidth("20%");
    }

    @Override
    public FullCalendarResourceItemsList getInitialResources() {
        var resources = new FullCalendarResourceItemsList();
        resources.add(new FullCalendarResourceItem().setId("r1").setTitle("Room A"));
        resources.add(new FullCalendarResourceItem().setId("r2").setTitle("Room B"));
        return resources;
    }

    @Override
    public FullCalendarEventsList getInitialEvents() {
        var events = new FullCalendarEventsList();
        events.add(new FullCalendarEvent<>()
            .setTitle("Meeting")
            .setResourceId(List.of("r1"))
            .setStart(LocalDateTime.of(2026, 5, 10, 9, 0))
            .setEnd(LocalDateTime.of(2026, 5, 10, 10, 30)));
        return events;
    }
}
\`\`\``;
}
